import { type ReactElement, type ReactNode } from 'react';
import { Island, VStack } from '@direct-frontend/components';
import { isFunction } from '@direct-frontend/stdlib';

export function renderIsland({
    fullRender,
    renderContent,
    content,
    islandContainerClassName,
    islandClassName,
}: {
    fullRender?: () => ReactElement;
    renderContent?: () => ReactElement;
    content: ReactNode;
    islandContainerClassName: string;
    islandClassName: string;
}) {
    if (isFunction(fullRender)) {
        return fullRender();
    }

    return (
        <VStack className={islandContainerClassName}>
            <Island className={islandClassName} alignItems="center" justifyContent="center">
                {renderContent ? renderContent() : content}
            </Island>
        </VStack>
    );
}
